import { Vector2, Vector3 } from 'three';
import Representation3d from './Representation3d';
import Representation3dTypeEnum from './Representation3dTypeEnum';

import IPlacement from '../../interfaces/IPlacement3d';
import Placement3d from '../Placement3d';

import apiExtrudedAreaSolidSchema from '../../services/bimVisualizerApi/schema/representation3d/apiExtrudedAreaSolidSchema';
import { sceneUnitsFromMm, getScaledVector2, getScaledVector3 } from '../../utils/scaler';


export default class ExtrudedAreaSolid extends Representation3d {
    
    outerProfile: Vector2[] = [];
    voids: Vector2[][] = [];
    placement: IPlacement;
    extrudedDirection: Vector3 = new Vector3();
    depth: number = 0;

    constructor(outerProfile: Vector2[], voids: Vector2[][], placement: IPlacement, extrudedDirection: Vector3, depth: number, materialId: number | null) {
        super(Representation3dTypeEnum.ExtrudedAreaSolid, materialId);
        this.outerProfile = outerProfile;
        this.voids = voids; 
        this.placement = placement;
        this.extrudedDirection = extrudedDirection;
        this.depth = depth;
    }

    clone() : Representation3d {
        return new ExtrudedAreaSolid(   this.outerProfile.map(v => v.clone()), 
                                        this.voids.map(v => v.map(v => v.clone())), 
                                        this.placement.clone(),
                                        this.extrudedDirection.clone(), 
                                        this.depth, 
                                        this.materialId);
    }
    
    static fromJSON(json: any): Representation3d {

        const parsed = apiExtrudedAreaSolidSchema.parse(json);

        const outerProfile = parsed.outerProfile.map((v: any) => getScaledVector2({...v}));

        // TODO: Parse voids

        return new ExtrudedAreaSolid(   outerProfile, [], 
                                        Placement3d.fromJSON(parsed.placement),
                                        new Vector3(    parsed.extrudedDirection.x, 
                                                        parsed.extrudedDirection.y, 
                                                        parsed.extrudedDirection.z), 
                                        sceneUnitsFromMm(parsed.depth),
                                        parsed.materialId);
        
    }

}